<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <!-- Dashboard Box -->

                        <div class="col-lg-8 col-md-7 col-xs-12 col-xl-5">
                            <div class="tabs tabs-default margin-top-0 margin-bottom-15">
                                <div class="tabs-header">
                                    <ul style="width: 100%;">
                                        <li style="width: 50%;" v-bind:class="{'active': tab == 'visualizar'}">
                                            <a v-on:click="setTab('visualizar')">
                                                <i class="material-icons">trending_up</i>
                                                Visualizar
                                            </a>
                                        </li>
                                        <li style="width: 50%;" v-bind:class="{'active': tab == 'editar'}">
                                            <a v-on:click="setTab('editar')">
                                                <i class="material-icons">edit</i>
                                                Editar
                                            </a>
                                        </li>                                       
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div class="col-xl-12 tab-visualizar" v-show="tab == 'visualizar'">
                        
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get">
                                <div class="row">
                                    <div class="col-lg-3 col-xs-6 col-xl-2 col-md-3">
                                        <div class="submit-field">
                                            <h5>Mês:</h5>
                                            <select class="with-border" v-model="form.mes">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option value="1" selected>Janeiro</option>
                                                <option value="2" selected>Fevereiro</option>
                                                <option value="3" selected>Março</option>
                                                <option value="4" selected>Abril</option>
                                                <option value="5" selected>Maio</option>
                                                <option value="6" selected>Junho</option>
                                                <option value="7" selected>Julho</option>
                                                <option value="8" selected>Agosto</option>
                                                <option value="9" selected>Setembro</option>
                                                <option value="10" selected>Outubro</option>
                                                <option value="11" selected>Novembro</option>
                                                <option value="12" selected>Dezembro</option>
                                            </select>                                            
                                        </div>
                                    </div>    
                                    <div class="col-lg-4 col-xs-6 col-xl-2 col-md-3">
                                        <div class="submit-field">
                                            <h5>Ano:</h5>
                                            <input type="number" v-model="form.ano" class="with-border">
                                        </div>
                                    </div>                                                                        
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 


                            <div class="margin-top-20" v-for="(item, index) in Object.keys(data.itens)">
                                <h3 class="margin-bottom-10">
                                    <i class="material-icons">store</i>
                                    <b>{{item}}</b>
                                </h3>
                                <div style="padding: 15px">
                                    <div class="row" style="border: 1px solid #ddd; background: #fff;">
                                        <div class="col-xl-4 col-md-6 col-lg-6 col-xs-12 tanque" v-for="(item2, index) in data.itens[item]" style="text-align: center;">
                                            <h4>
                                                <b>{{item2.nome}}</b> (<b>{{item2.porcentagem}}%</b>)
                                                <br>                        
                                            </h4>
                                            <img :src="$root.config.url + '/' + item2.imagem" style="width: 120px; margin-bottom: 15px">
                                            <div style="width: 100%; padding-left: 15px; padding-right: 15px;" class="">
                                                <div class="progress margin-bottom-15">
                                                    <div class="progress-bar" :style="{'width': item2.porcentagem + '%'}" style="max-width: 100% !important;"></div>
                                                </div>
                                            </div>
                                            <p>
                                                Quantidade atual: <b>{{parseFloat(item2.atual).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L</b> (<b>{{item2.porcentagem}}%</b>)
                                            </p>
                                            <p>
                                                Meta: <b>{{parseFloat(item2.total).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L</b>
                                            </p>
                                            <p style="font-size: 16px; font-weight: 500; color: #333; margin-top: 10px;">
                                                Recompensa: 
                                                <span class="dashboard-status-button color-orange" style="margin-left: 5px;">
                                                    {{item2.recompensa}}
                                                </span>                                                                                                                           
                                            </p>                                                                                                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>  

                        <div class="col-xl-12 tab-editar" v-show="tab == 'editar'">

                            <router-link v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" :to="{'name': 'CadastrarMetas'}" class="button block-mobile margin-top-10">
                                <i class="material-icons">add</i>
                                Cadastrar meta
                            </router-link>


                            <div class="table-scroll margin-top-20" style="overflow-x: scroll;">

                                <div v-for="(item, index) in Object.keys(data.itens)">
                                    <h4 class="margin-bottom-10">
                                        <i class="material-icons">store</i>
                                        <b>{{item}}</b>
                                    </h4>

                                    <table class="table table-bordered table-bordered-default table-responsive margin-bottom-20">
                                        <thead>
                                            <th style="min-width: 10px; width: 30px;">
                                                ID
                                            </th>
                                            <th style="min-width: 180px;">
                                                Nome
                                            </th>   
                                            <th style="min-width: 130px; width: 130px;">
                                                Quantidade atual
                                            </th>
                                            <th style="min-width: 100px; width: 100px;">
                                                Meta
                                            </th>      
                                            <th style="min-width: 100px; width: 100px;">
                                                Recompensa
                                            </th>                                                                                        
                                            <th style="min-width: 140px; width: 140px;">
                                                Atualização
                                            </th>   
                                            <th style="min-width: 132px; width: 132px;">
                                                Ações
                                            </th>                                                                      
                                        </thead>
                                        <tbody>


                                            <tr v-show="data.itens[item].length == 0 && loaded">
                                                <td data-label="" colspan="7">
                                                    Nenhum resultado encontrado.
                                                </td>                                                                                           
                                            </tr>
                                           
                                            <tr v-for="(item2, index) in data.itens[item]">
                                                <td data-label="ID">
                                                    {{item2.id}}                                  
                                                </td>
                                                <td data-label="Nome" style="">
                                                    {{item2.nome}}                                               
                                                </td>                                                                               
                                                <td data-label="Atual" style="">
                                                    {{parseFloat(item2.atual).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L ({{item2.porcentagem}}%)
                                                </td>
                                                <td data-label="Total" style="">
                                                    {{parseFloat(item2.total).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L
                                                </td>                                                        
                                                <td data-label="Recompensa" style="">
                                                    {{item2.recompensa}}
                                                </td>             
                                                <td data-label="Última atualização" style="">
                                                    {{item2.atualizacao |formatDate}}
                                                </td>                                                                 
                                                <td data-label="Ações">
                                                    <router-link v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" :to="{'name': 'EditarMetas', 'query': {'c': item2.cod}}" class="dashboard-status-button gray">Editar</router-link>
                                                    <a v-on:click="del(item2.cod)" class="dashboard-status-button color-red">Apagar</a>                                                   
                                                </td>                                                                                             
                                            </tr>
                                                                                 
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                
                    </div>

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Metas',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 1})                
            } else {
                return "0,00";
            }
            // return value.toLocaleString('pt-br', minimumFractionDigits: 2)                
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "tab":                  (self.$root.tmp.estoque.tab ? self.$root.tmp.estoque.tab : "visualizar"),
            "visualizar": {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "historico": {
                "itens":            []
            },
            "clientes": {
                "itens":            []
            },
            "empresas": {
                "itens":            []
            },
            "catalogo": {
                "itens":            []
            },            
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "empresaCod":       "",
                "mes":              (new Date().getMonth()+1),
                "ano":              (new Date().getFullYear()),
                "itens":            []
            },
        }
    },
    watch: {
        "form.ano": function(val) {
            console.log("watch > form.ano", val);
            var self = this;
            self.get();
        },
        "form.mes": function(val) {
            console.log("watch > form.mes", val);
            var self = this;
            self.get();
        }                                
    },
    methods: {
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            self.tab        = tab;

            if (tab == "editar" || tab == "visualizar" || tab == "lista") {
                self.get();
            }      

        },   
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/metas.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get().then(function() {
                        loading.hide();
                    }).catch(function() {
                        loading.hide();
                    });
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },    
        getEmpresas: function() {
            var self        = this;
            console.log("getEmpresas()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "empresas",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("getEmpresas() response", response);
                    self.empresas       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEmpresas() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },                       
        get: function() {
            var self        = this;
            console.log("get()", self.data);
            self.data.itens = [];
            self.loaded     = false;
            loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo == "prestador") {
                    self.form.empresaCod = self.$root.user.empresaCod;
                }

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "empresaCod":   self.form.empresaCod,
                        "ano":          self.form.ano,
                        "mes":          self.form.mes
                    }
                };

                axios.get("api/metas.php", form)
                .then(response => {
                    
                    console.log("get() response", response);

                    var keys = Object.keys(response.data.result.itens);
                    console.log("keys", keys);
                    keys.forEach(function(key) {
                        console.log("key>", key);
                        response.data.result.itens[key].forEach(function(item, index) {
                            var porcentagem = (parseFloat(item.atual) / parseFloat(item.total)) * 100;
                            response.data.result.itens[key][index]["porcentagem"] = porcentagem > 0 ? (porcentagem).toFixed(1) : 0;
                        });
                    });

                    self.data.itens     = response.data.result.itens; 
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
                    // if (self.tab == "visualizar") self.loadChart();
                    self.$root.scrollTop();
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        init: function() {
            var self = this;

            self.$root.tmp.estoque.tab = "";

            Promise.all([
                self.get(),
                self.getEmpresas(),
            ]).then(function() {
            
                loading.hide();
            }).catch(function(error) {
                loading.hide();
            });             
        }
    },
    created: function() {
        var self = this;
        loading.show();        

        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }      



        // var empresaCod = [
        //   "9cc54e6de7582589b0b1d7e8bcb2aa99",
        //   "33613cc5c4bde26c70133b9564940f32",
        //   "d86e5d47a1473c6b309e736b108f948d",
        //   "a0dc1e57f684d516d4530c29052b72f3",
        //   "950d9f087df557237f4d2fe8e610d493",
        //   "df7da4031c78598984866d17b40292e5",
        //   "f43a47fa913c0000426138a7748a53c9",
        //   "03528609b09f719add1579a1c471f95a",
        //   "7667916b5c7b2e5b59f9ea058f1a4bb0"
        // ];
        // var itens = [
        //   {
        //     "nome": "Bronze",
        //     "subtitulo": "25 mil litros",
        //     "recompensa": "BÔNUS 100",
        //     "total": 25000,
        //     "imagem": "images/bronze.png"
        //   },
        //   {
        //     "nome": "Silver",
        //     "subtitulo": "35 mil litros",
        //     "recompensa": "BÔNUS 150",
        //     "total": 35000,
        //     "imagem": "images/silver.png"
        //   },
        //   {
        //     "nome": "Gold",
        //     "subtitulo": "45 mil litros",
        //     "recompensa": "BÔNUS 200",
        //     "total": 45000,
        //     "imagem": "images/gold.png"
        //   },
        //   {
        //     "nome": "Platinum",
        //     "subtitulo": "60 mil litros",
        //     "recompensa": "BÔNUS 300",
        //     "total": 60000,
        //     "imagem": "images/platinum.png"
        //   },
        //   {
        //     "nome": "Diamond",
        //     "subtitulo": "70 mil litros",
        //     "recompensa": "BÔNUS 500",
        //     "total": 70000,
        //     "imagem": "images/diamond.png"
        //   }
        // ];

        // function sequence(tasks, fn) {
        //     return tasks.reduce((promise, task) => promise.then(() => fn(task)), Promise.resolve());
        // }

        // sequence(empresaCod, function(item) {
        //     return new Promise(function(resolve, reject) {

        //         itens.forEach(function(item2) {

        //             item2.empresaCod= item;
        //             item2._cod      = "5c11b2ed463bf338399d1658770aea8a";
        //             item2._token    = "73f1b0792629aa20asdasasdas7566a1a580ff09d3cd5475747ef176fc324c5e2727a3b890";

        //             axios.post("api/metas.php", item2)
        //             .then(response => {
                      
        //                 console.log("submit() response", response)
        //                 resolve(response);
        //             })
        //             .catch(error => {
        //                 console.log("submit() error", error)
        //                 resolve(error);
        //             });

        //         })
        //     });
        // });


    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .tab-visualizar h3 {
        color: #666;
    }
    .tanque {
        border: 1px solid #ddd;
        text-align: center;
        padding: 2%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #fff;
    }
    .tanque h1 {
        position: absolute;
        /*display: block;*/
        /*margin: 0 auto;*/
        text-align: center;
    }
    .tanque h4 {
        text-align: center;
        font-size: 1.1em;
        margin-bottom: 15px;
    }
    .tanque-nivel {
        width: 100%;
        background: #ddd;
        height: 10%;
        position: relative;
        bottom: 0px;
        z-index: -1;
    }
    .tanque p {
        margin-bottom: 0px;
    }
    .tanque p b {
        color: #333;
    }

    .tanque-area {
        display: flex;
        align-items: flex-end;
        align-content: center;
        border-bottom-right-radius: 100%;
        border-bottom-left-radius: 100%;
        /*text-align: center;*/
        width: 10em;
        height: 10em;
        border-radius: 50%;
        border: 2px solid #666;
    }

    .dashboard-status-button.color-green {
        /*display: block; */
        /*background: #F89012 !important;*/
        margin-top: 5px; 
        color: #fff !important;
        width: auto; 
        padding: 2px 8px;
        text-align: center;
    }

    .dashboard-status-button.color-green i {
        font-size: 16px;
        color: #fff;
    }

    .progress {
        width: 100%;
        background: #ddd;
        height: 25px;
    }

    .progress-bar {
        /*width: 100%;*/
        background: #4cd964;
        height: 25px;
    }    
</style>



// WEBPACK FOOTER //
// src/components/Metas.vue